import { VStack } from '@chakra-ui/react';
import React from 'react';
import ReactHlsPlayer from 'react-hls-player';
const VideoPlayer = () => {
    return (
        <VStack>
              <ReactHlsPlayer
                src="https://54.147.245.89:8443/live/UG1VPZJH/index.m3u8"
                autoPlay={false}
                controls={true}
                width="100%"
                height="auto"
                style={{borderRadius:"20px"}}
            />
        </VStack>
    );
};

export default VideoPlayer;